import SurveysService from '../../services/surveys-service';
import SurveysSingleResponse from './SurveysSingleResponse';
import Vue from 'vue';
import DateRangePicker from 'vue2-daterange-picker';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import LabelizeMixin from '../../mixins/LabelizeMixin.vue';
import moment from 'moment';

Vue.component('surveys-single-response', SurveysSingleResponse);
Vue.component('surveys-responses', {
  components: { DateRangePicker, VueSlider },
  mixins: [LabelizeMixin],
  computed: {
    activeMiniFilter() {
      const filters = this.filters;
      for (let filter of this.miniFilters) {
        if (Object.keys(filters).includes(filter)) {
          return { value: this.filters[filter], key: filter };
        }
      }
      return null;
    },
    exportLink() {
      const append =
        '?token=' +
        Spark.jwtToken +
        '&fromDate=' +
        moment(this.filters.dateRange.startDate).format('YYYY-MM-DD') +
        '&toDate=' +
        moment(this.filters.dateRange.endDate).format('YYYY-MM-DD');
      return `/surveys/${Spark.state.currentTeam.id}${
        this.filters.surveyId > 0 ? `/${this.filters.surveyId}/` : '/'
      }responses/export${append}`;
    },
  },
  data() {
    return {
      surveys: [],
      results: {},
      loading: false,
      miniFilters: ['language', 'nationality', 'roomNumber', 'source'],
      filters: {
        responseId: 0,
        dateRange: {
          startDate: moment().startOf('year').toDate(),
          endDate: moment().toDate(),
        },
        averageScoreRange: [1, 10],
        surveyId: 0,
        activeFilter: 0,
      },
      pickerOptions: {
        // Instagram launch date :P
        // minDate: '2010-10-06',
        minDate: null,
        maxDate: null,
        opens: 'center',
        singleDatePicker: false,
        localeDate: { firstDay: 1, format: 'DD-MM-YYYY' },
      },
    };
  },
  mounted() {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri.replace('#', ''));

    this.filters.responseId = params.get('responseId') ? params.get('responseId') : 0;
    this.getSurveys();
    this.getResponses();

    this.$eventHub.$on('applySurveyResponseFilters', (data) => {
      this.applyFilters(data);
      this.getResponses();
    });
  },
  methods: {
    removeFilter(key) {
      Vue.delete(this.filters, key);
      this.getResponses();
    },
    resetFilters() {
      this.filters = {
        responseId: 0,
        dateRange: {
          startDate: moment().startOf('year').toDate(),
          endDate: moment().toDate(),
        },
        averageScoreRange: [1, 10],
        surveyId: 0,
        activeFilter: 0,
      };
    },
    async clearFilters() {
      this.resetFilters();
      await this.getResponses();
    },
    applyFilters(filters) {
      this.resetFilters();
      for (let filter of Object.keys(filters)) {
        this.filters[filter] = filters[filter];
      }
    },
    async getSurveys() {
      const surveys = await SurveysService.index();
      this.surveys = surveys.data;
    },
    async getResponses(page) {
      this.loading = true;

      const filters = {
        from: this.filters.dateRange.startDate,
        to: this.filters.dateRange.endDate,
        minAverageScore: this.filters.averageScoreRange[0],
        maxAverageScore: this.filters.averageScoreRange[1],
      };

      switch (this.filters.activeFilter) {
        case 1:
          filters.containsNegative = true;
          break;
        case 2:
          filters.withoutAnswer = true;
          break;
      }
      
      if (this.filters.surveyId > 0) filters.surveyId = this.filters.surveyId;
      if (this.filters.responseId > 0) filters.responseId = this.filters.responseId;
      for (let filter of this.miniFilters) {
        if (this.filters[filter]) {
          filters[filter] = this.filters[filter];
        }
      }
      if (this.filters.language) {
        filters.language = this.filters.language;
      }

      this.results = await SurveysService.responses.index(page, filters);
      this.page = page;
      setTimeout(() => {
        this.loading = false;
      }, 200);
    },
  },
});
